// This file is auto-generated by running `yarn svg:process`

import * as React from 'react'

export const TrashSvg = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      height={props.height}
      width={props.width}
      fill={props.fill}
    >
      <path d="M217.5 129.4c-3.7 1.7-7 5.2-8.4 8.9-.6 1.6-1.1 8.9-1.1 16.3V168h-32v16h160v-16h-31.9l-.3-14.9c-.3-16.3-.8-17.8-7.2-22.5-2.6-2-4.1-2.1-39.4-2.3-29.1-.2-37.3 0-39.7 1.1zM288 156v12h-64v-24h64v12zM186.5 209.6c-4.6 2.4-6.3 4.3-8 8.9-1.6 4.1-1.5 5.6 9.4 78.6 12.3 82.3 12 81.2 19.5 84.9 4.1 1.9 6.1 2 48.6 2s44.5-.1 48.6-2c7.5-3.7 7.2-2.6 19.5-84.9 11-73.8 11-74.4 9.4-78.8-1-2.5-3.1-5.5-5.3-7.1l-3.5-2.7-67.6-.3c-59.9-.2-67.9 0-70.6 1.4zm131.8 16.6c-.2 1.3-4.8 32.4-10.3 69.3-5.5 36.9-10.3 68.2-10.6 69.7l-.6 2.8h-81.6l-.6-2.8c-.3-1.5-5.1-32.8-10.6-69.7-5.5-36.9-10.1-68-10.3-69.3l-.4-2.2h125.4l-.4 2.2z" />
      <path d="M248 296v40h16v-80h-16v40z" />
    </svg>
  )
}
